import Repo from './Repo.js'

export default class ProductRepository extends Repo {
  constructor () {
    super('products')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  getGroupations(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/groupations', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachGroupation(id, groupation_id){
    return this.http.post(this.resource + '/' + id + '/groupations/' + groupation_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachGroupation(id, groupation_id){
    return this.http.delete(this.resource + '/' + id + '/groupations/' + groupation_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getProductSizes(id, include) {
    return this.http.get(this.resource + '/' + id + '/product-sizes', {include: include}).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
